export default __webpack_public_path__ + "static/media/radio-check-leaf.ca36bdf1.svg";